import { createTheme } from "@material-ui/core";

const theme = createTheme({
  palette: {
    primary: {
      main: "#997DB5",
    },
    secondary: {
      main: "#8BC7B5",
    },
  },
  typography: {
    fontFamily: ["Source Sans Pro", "sans-serif"],
    fontSize: 16,
  },
});

export default theme;
